import { takeLeading, put, select } from 'redux-saga/effects'
import {
  CREATE_PTO_TEMPLATE,
  postCreatePtoTemplate,
} from 'actions/powerTakeOff'
import { getVehicleRouteMatch } from 'selectors/router'

export function* watchCreatePtoTemplate() {
  yield takeLeading(CREATE_PTO_TEMPLATE, submitCreateTemplate)
}

function* submitCreateTemplate(action) {
  const { templatePayload } = action

  const {
    params: { id: serialNumber },
  } = yield select(getVehicleRouteMatch)

  yield put(postCreatePtoTemplate(serialNumber, templatePayload))
}
